import React from 'react';
import PropTypes from 'prop-types';
import { Form, Button } from 'react-bootstrap';
const uuid = require('uuid');
const find = require('lodash/find');

const Strings = require("../../../../app/shared/Strings");
const OrganizationActions = require('../../actions/OrganizationActions');
import AccessibleIcon from '../common/AccessibleIcon';
import WithChannelActivities from '../DataHOCs/WithChannelActivities';
import WithOrganizationIntegrationTags from '../DataHOCs/WithOrganizationIntegrationTags';
import WithOrganizationTagImportChanges from '../DataHOCs/WithOrganizationTagImportChanges';
import SortableTableClassic from '../table/SortableTableClassic';
import OrgIntegrationTagEditor from './OrgIntegrationTagEditor';
import OrgIntegrationTagImportChanges from './OrgIntegrationTagImportChanges';
import { DeleteTagWarning, ImportTagsInfo, ExportTagsInfo, TagNameInfo } from './OrgIntegrationTagInfoWarnings';
import TagHelp from '../Tags/TagHelp';
import Tooltip from '../common/Tooltip';
import ConfirmModal from '../modal/ConfirmModal';
import SingleAssetInput from '../common/SingleAssetInput';
const AssetUtil = require('../../util/asset');
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    orgId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    orgIntegrationTags: PropTypes.array.isRequired,
    organizationStoreAction: PropTypes.object.isRequired,
    orgTagImportChanges: PropTypes.shape({
        tagsToAdd: PropTypes.array,
        tagsToDelete: PropTypes.array,
        tagsToUpdate: PropTypes.array,
        existingTagsHash: PropTypes.string.isRequired,
    })
};

const defaultProps = {
    orgTagImportChanges: null
};

class OrgIntegrationTagsView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            newTagName: '',
            newTagDescription: '',
            selectedTagId: null,
            setConfirmDeleteTagModal: false,
            importTagsActionId: null,
            importTagsError: null,
        };

        this.onActiveTagClick = this.onActiveTagClick.bind(this);
        this.onUpdateNewTagName = this.onUpdateNewTagName.bind(this);
        this.onUpdateNewTagDescription = this.onUpdateNewTagDescription.bind(this);

        this.setConfirmDeleteTagModalState = this.setConfirmDeleteTagModalState.bind(this);
        this.onDeleteTag = this.onDeleteTag.bind(this)

        this.onAddTag = this.onAddTag.bind(this);
        this.getExportCsvHref = this.getExportCsvHref.bind(this);
        this.importCsv = this.importCsv.bind(this);
    }

    componentDidUpdate() {
        let newState = {};
        if (this.state.selectedTagId && !this.props.orgIntegrationTags.find(t => t.id === this.state.selectedTagId)) {
            newState = { ...newState, selectedTagId: null };
        }
        
        if (this.props.organizationStoreAction.id === this.state.importTagsActionId) {
            newState = {
                ...newState,
                importTagsActionId: null,
                importTagsError: this.props.organizationStoreAction.error || null,
            };
        }

        if (Object.keys(newState).length > 0) {
            this.setState(newState);
        }
    }

    onActiveTagClick(e, tagId) {
        this.setState({ selectedTagId: tagId, setConfirmDeleteTagModal: false });
    }

    onUpdateNewTagName(e) {
        this.setState({ newTagName: e.target.value });
    }

    onUpdateNewTagDescription(e) {
        this.setState({ newTagDescription: e.target.value });
    }

    setConfirmDeleteTagModalState(showBool) {
        this.setState({ setConfirmDeleteTagModal: showBool });
    }

    onDeleteTag() {
        this.setConfirmDeleteTagModalState(false);

        OrganizationActions.deleteOrgIntegrationTag(uuid.v4(), {
            orgId: this.props.orgId,
            tagId: this.state.selectedTagId,
        });
    }

    onAddTag() {
        if (!this.state.newTagName) {
            return;
        }

        OrganizationActions.addOrgIntegrationTag(uuid.v4(), {
            orgId: this.props.orgId,
            tag: this.state.newTagName,
            description: this.state.newTagDescription,
        });

        this.setState({ newTagName: '', newTagDescription: '' });
    }

    getExportCsvHref() {
        return `/authoring/organization/${this.props.orgId}/integration_tags/csv`;
    }

    importCsv(params, files) {
        const importTagsActionId = uuid.v4();
        this.setState({ importTagsActionId: importTagsActionId }, () => {
            params = {
                ...params,
                orgId: this.props.orgId,
            };

            OrganizationActions.importIntegrationTagsCsv(importTagsActionId, params, files);
        });
    }

    render() {
        const selectedTag = this.state.selectedTagId ? this.props.orgIntegrationTags.find(t => t.id === this.state.selectedTagId) : null;

        return (
            <div>
                <div className="channelHeadingFlex">
                    <div className="channelHeadingFlex__heading">
                        { !!this.props.backHandler &&
                                <button
                                className="btn btn-primary glyph btn-circle btn-lg margin-right-15"
                                onClick={this.props.backHandler}
                                title="Back">
                                    <AccessibleIcon
                                    label="Back">
                                        <span className="fa fa-chevron-left" aria-hidden={true}/>
                                    </AccessibleIcon>
                                </button>
                        }
                        <h2 className="heading-lg">{this.props.heading}</h2>
                    </div>
                </div>

                <TagHelp className="padding-all-md tile-dash-floating margin-bottom-xl" />

                <h2 className="view-title">Add Integration Tag</h2>
                <Form bsPrefix="form tile-dash-floating margin-bottom-xl">
                    <Form.Group controlId="new-tag-name">
                        <Form.Label>Tag Name (e.g. ISBN)</Form.Label>
                        <Tooltip id="orgtv-td" className="margin-left-sm" placement="right">
                            <TagNameInfo />
                        </Tooltip>
                        <Form.Control
                            as="input"
                            value={this.state.newTagName}
                            onChange={this.onUpdateNewTagName}
                        />
                    </Form.Group>
                    <Form.Group controlId="new-tag-description">
                        <Form.Label>Tag Description (optional, e.g. title, author, edition)</Form.Label>
                        <Tooltip id="orgtv-td" className="margin-left-sm" placement="right">
                            {Strings['en'].integration.TAG_DESCRIPTION_DESC}
                        </Tooltip>
                        <Form.Control
                            as="input"
                            value={this.state.newTagDescription}
                            onChange={this.onUpdateNewTagDescription}
                        />
                    </Form.Group>
                    <div className="text-right">
                        <Button variant='primary' disabled={!this.state.newTagName}  onClick={this.onAddTag}>Add</Button>
                    </div>
                </Form>

                <h2 className="view-title">Import/Export Integration Tags</h2>
                <div className="tile-dash-floating margin-bottom-xl">
                    <div className="margin-bottom-xl">
                        <h3 className="md-heading margin-bottom-lg">Export Tags</h3>
                        <ExportTagsInfo className="font-size-14px margin-bottom-lg line-height-16px" />
                        <div className="text-centered">
                            <a className="link-plain btn btn-primary" href={this.getExportCsvHref()}>
                                Export CSV
                            </a>
                        </div>
                        
                    </div>
                    <div>
                        <h3 className="md-heading margin-bottom-lg">Import Tags</h3>
                        <ImportTagsInfo className="font-size-14px margin-bottom-md line-height-16px" />
                        <TagNameInfo className="font-size-14px margin-bottom-lg" />
                        {!this.props.orgTagImportChanges ?
                            <div>
                                <ErrorBox error={this.state.importTagsError} />
                                <div className="text-centered">
                                    <SingleAssetInput
                                        buttonOnly
                                        browseText="Import CSV"
                                        assetType="csv"
                                        assetRole="tags"
                                        accept="text/csv, .csv"
                                        disabled={!!this.props.orgTagImportChanges}
                                        onChange={this.importCsv}
                                        onError={(err) => {console.log(err)}}
                                        validateAssetType={AssetUtil.validateCsvMimeType}
                                    />
                                </div>
                                
                            </div>
                            :
                            <div className="bg-color-white padding-all-md">
                                <h3 className="sm-heading margin-bottom-lg">Pending Changes From Import</h3>
                                <div className="sub-heading">
                                    The imported changes have not yet been finalized. Please review and click 'Confirm Changes' to finalize.
                                </div>
                                <OrgIntegrationTagImportChanges orgId={this.props.orgId} />
                            </div>
                        }
                    </div>
                </div>

                <h2 className="view-title">Active Integration Tags</h2>
                <div className="tile-dash-floating margin-bottom-xl">
                    <SortableTableClassic
                        classNameTableContainer="margin-bottom-xl"
                        onRowClick={this.onActiveTagClick}
                        rows={this.props.orgIntegrationTags}
                        selectedRowKey={this.state.selectedTagId}
                        dateFormat="YYYY-MM-DD HH:mm zz"
                        defaultSort={{ key:'tag', type:'string', asc: true }}
                        tableHeight={500}
                        columns={[
                            {
                                displayName: 'Tag Name',
                                key:'tag',
                                size: 2,
                                type: 'string',
                                caseSensitive: true,
                            },
                            {
                                displayName: 'Description',
                                key:'description',
                                size: 2,
                                type: 'string'
                            },
                            {
                                displayName: 'Created At',
                                key:'created_at',
                                size: 3,
                                type: 'date'
                            },
                        ]}
                    />
                </div>

                <h2 className="view-title">Edit Integration Tag</h2>
                {selectedTag ?
                    <OrgIntegrationTagEditor
                    className="margin-bottom-xl margin-top-lg tile-dash-floating"
                    key={selectedTag.id}
                    tagRecord={selectedTag}
                    onDelete={this.setConfirmDeleteTagModalState.bind(this, true)}
                    />
                    :
                    <div className="margin-bottom-xl">Select an Integration Tag from the table to edit...</div>
                }
                { this.state.setConfirmDeleteTagModal &&
                    <ConfirmModal
                        show={this.state.setConfirmDeleteTagModal}
                        modalTitle="Delete Tag"
                        text={
                            <div className="font-size-14px">
                                <DeleteTagWarning />
                                <div className="margin-top-sm font-weight-bold text-centered">
                                    Are you sure you want to delete this tag?
                                </div>
                            </div>
                        }
                        buttonText="confirm delete"
                        confirmButtonBsStyle="danger"
                        confirmHandler={this.onDeleteTag}
                        cancelButtonText="cancel"
                        cancelHandler={this.setConfirmDeleteTagModalState.bind(this, false)}
                        closeHandler={this.setConfirmDeleteTagModalState.bind(this, false)}
                    />
                }
            </div>
        );
    }
}

OrgIntegrationTagsView.propTypes = propTypes;
OrgIntegrationTagsView.defaultProps = defaultProps;

export default WithOrganizationIntegrationTags(WithOrganizationTagImportChanges(WithChannelActivities(OrgIntegrationTagsView)));
